import { checkEnvironment } from '@saviynt/common';

const getRequestFileUploadApiUrl = (userName, requestKey) => {
  const { GATEWAY_API_URL } = checkEnvironment();

  return `${GATEWAY_API_URL}/api/pam/requests/${requestKey}/attachment/upload?uploadedBy=${userName}`;
};

export default getRequestFileUploadApiUrl;
